import { call, put, takeLatest } from 'redux-saga/effects';
import { addToRootSaga } from 'store';
import { addPositiveToast, addNegativeToast } from 'modules/toastContainer';
import { deleteWorkflowWebhook, cloneWorkflowWebhook } from 'api/WorkflowWebhooksAPI';
import { CopyWorkflowWebhookToast } from './components/CopyWorkflowWebhookToast';
import * as actionTypes from './actionTypes';

export function* copyWorkflowWebhookSaga({
  payload: { workflowWebhook, workflowWebhookName, onCopy },
}) {
  try {
    const response = yield call(cloneWorkflowWebhook, workflowWebhook.id, workflowWebhookName);

    yield put(
      addPositiveToast(
        <CopyWorkflowWebhookToast
          copiedWorkflowName={workflowWebhook.name}
          newWorkflowId={response.data.id}
        />,
      ),
    );
    onCopy();
  } catch (error) {
    yield put(
      addNegativeToast(`Copy of ${workflowWebhook.name} could not be copied. Please try again.`),
    );
  }
}

export function* deleteWorkflowWebhooksSaga({ payload: { workflowWebhooks, onDelete } }) {
  let succeeded = 0;
  let failed = 0;

  for (let i = 0; i < workflowWebhooks.length; i += 1) {
    const { id } = workflowWebhooks[i];
    try {
      yield call(deleteWorkflowWebhook, id);
      onDelete(id);
      succeeded += 1;
    } catch (error) {
      failed += 1;
    }
  }

  if (succeeded > 0) {
    try {
      yield put(
        addPositiveToast(
          `${workflowWebhooks.length} webhook${
            workflowWebhooks.length > 0 ? 's' : ''
          } successfully deleted`,
        ),
      );
    } catch (e) {
      yield put(
        addNegativeToast(
          `${workflowWebhooks.length} webhook${
            workflowWebhooks.length > 0 ? 's' : ''
          } could not be deleted. Please try again.`,
        ),
      );
    }
  }

  if (failed > 0) {
    try {
      yield put(
        addNegativeToast(
          `${workflowWebhooks.length} webhook${
            workflowWebhooks.length > 0 ? 's' : ''
          } could not be deleted. Please try again.`,
        ),
      );
    } catch (e) {
      yield put(
        addNegativeToast(
          `${workflowWebhooks.length} webhook${
            workflowWebhooks.length > 0 ? 's' : ''
          } could not be deleted. Please try again.`,
        ),
      );
    }
  }

  onDelete();
}

addToRootSaga([
  takeLatest(actionTypes.DELETE_WORKFLOW_WEBHOOKS_REQUEST, deleteWorkflowWebhooksSaga),
  takeLatest(actionTypes.COPY_WORKFLOW_WEBHOOK_REQUEST, copyWorkflowWebhookSaga),
]);
